import { IStreamData } from "@formant/core/model/IStreamData";
import { StreamType } from "@formant/core/model/StreamType";

import { IDeviceStreamData } from "./IDeviceStreamData";

export function pointsByDevice<T extends StreamType>(
    datas: IStreamData<T>[],
): IDeviceStreamData<T>[] {
    return Object.values(
        datas.reduce<{
            [key: string]: IDeviceStreamData<T>;
        }>((acc, data) => {
            const { deviceId, name, type, tags, points } = data;
            const key = JSON.stringify({ deviceId, name, type });
            acc[key] = acc[key] || {
                deviceId,
                name,
                type,
                points: [],
            };
            const last = acc[key];
            last.points = last.points.concat(
                points.map(([timestamp, value]) => ({
                    time: new Date(timestamp),
                    value,
                    tags,
                })),
            );
            return acc;
        }, {}),
    ).map(data => ({
        ...data,
        points: data.points.sort((a, b) => a.time.getTime() - b.time.getTime()),
    }));
}
